import React, { useEffect, useState } from "react";
import image1 from "../assests/NIGST Campus/RAIN2057-2.jpg";
import image2 from "../assests/NIGST Campus/RAIN2070-2.jpg";
import image3 from "../assests/NIGST Campus/RAIN2093-2.jpg";
import imageHead from "../assests/G. VARUNA KUMAR, Addl SURVEYOR GENERAL.jpeg";
import { Link } from "react-router-dom";
import axios from "axios";
import BioDataModal from "./BioDataModal";

//static for showing in page
const StaticImages = [
  {
    title: "image1",
    path: image1,
  },
  {
    title: "image2",
    path: image2,
  },
  {
    title: "image3",
    path: image3,
  },
];

const MessageFromHead = {
  image: imageHead,
  name: "Addl. S.G. G.Varuna Kumar",
  description: "Shri G. Varuna Kumar, Additional Surveyor General, is heading National Institute for Geo-informatics Science & Technology (NIGST) since 3rd February 2025. Prior to this, he served as Deputy Surveyor General & Head, Faculty of Geodesy since May 2021.Joined as Deputy Superintending Surveyor in Survey of India in 1999 consequent upon selection through Engineering Services Examination. Completed Two-year rigorous training of Surveying Engineer course at Survey Training Institute (STI, now NIGST). Completed one year course in Advanced Geodesy at Survey Training Institute (STI)..."
};

const InformationDiv = {
  headingEnglish:
    "Welcome To National Institute for Geo-Informatics Science and Technology",
  englishPara:[
    "Survey of India,  established in the year 1767 is one of the oldest engineering departments of Govt. of India . In it's past 250+ years of glorious service to the nation, the entire country was mapped to provide cost effective, reliable and quality geospatial data to cater to the needs of national security and sustainable national development",
    "Post-Independence , with an impetus on developmental activities , urgent need for training the officers / staff of SoI in various aspects of Surveying and mapping,using state of art technologies, was recognised . With this objective, Centre for Survey training and Map production (CST & MP) was established in SoI campus, Hyderabad in 1967 as a Human resource development Institute under technical assistance from United Nations Development Programme (UNDP). Apart from imparting training to the departmental personnel, NIGST( erstwhile STI and IISM) conducts training programmes for other govt departments, Private organisations, Institutions from India as well as for Afro- Asian countries.",
    "The Institute leverages the domain expertise of guest Lecturers from department, Academia and industry to provide cutting edge technological insights to the trainees.",
    "NIGST has collaborated with premier institutes such as IIIT Hyderabad, IIT Kanpur, IIT Roorkee, IIT Tirupati, IIIT Hyderabad and other reputed organisations like AGI, NGRI etc. in areas of mutual interests, to foster knowledge sharing and academic excellence.",
    "NIGST provides excellent ambience for Learning with its lush green 100 acres campus, Boarding and Lodging facilities for about 200 trainees, State of art modern surveying Instruments, Labs equipped with latest gadgets and Library with 24/7 internet connectivity and e-granthalaya facility."
  ],
  headingHindi:
    "राष्ट्रीय भू-सूचना विज्ञान एवं प्रौद्योगिकी संस्थान (NIGST) में आपका स्वागत है",
  contentHindi: [
    "सर्वे ऑफ इंडिया, जो भारत सरकार का एक सबसे पुराना अभियान्त्रिकी विभाग है, राष्ट्रीय मानचित्रण एजेंसी के रूप में कार्य करता है और इसकी स्थापना वर्ष 1767 में हुई थी। राष्ट्र की 258 वर्षों की गौरवमयी सेवा के दौरान, सम्पूर्ण देश का मानचित्रण करके राष्ट्रीय सुरक्षा और सतत विकास की आवश्यकताओं को पूरा करने के लिए सुलभ, विश्वसनीय और गुणवत्तापूर्ण भू-स्थानिक डेटा प्रदान किया गया।",
    "स्वतंत्रता प्राप्ति के पश्चात, विकासात्मक गतिविधियों को बढ़ावा देने और रक्षा तत्परता सुनिश्चित करने हेतु, सर्वेक्षण और मानचित्रण के विभिन्न पहलुओं में सर्वे ऑफ इंडिया के अधिकारियों/कर्मचारियों को अत्याधुनिक तकनीकों के माध्यम से प्रशिक्षण देने की तत्काल आवश्यकता महसूस की गई। इसी उद्देश्य से वर्ष 1967 में हैदराबाद स्थित सर्वे ऑफ इंडिया परिसर में संयुक्त राष्ट्र विकास कार्यक्रम (UNDP) की तकनीकी सहायता से &quot;सर्वेक्षण प्रशिक्षण एवं मानचित्र निर्माण केंद्र&quot; (CST &amp; MP) की स्थापना एक मानव संसाधन विकास संस्थान के रूप में की गई।",
    "विभागीय कर्मचारियों को प्रशिक्षण देने के अतिरिक्त, NIGST (पूर्ववर्ती STI और IISM) भू-स्थानिक विज्ञान एवं प्रौद्योगिकी के क्षेत्र में एक प्रमुख प्रशिक्षण संस्थान है, जो भारत के विभिन्न सरकारी विभागों, निजी संगठनों, संस्थानों तथा एग्रो- एशियाई देशों के प्रतिभागियों को प्रशिक्षण प्रदान करता है।",
    "संस्थान, विभाग, अकादमिक जगत और उद्योग से आमंत्रित अतिथि व्याख्याताओं के विशेषज्ञ ज्ञान का लाभ उठाकर प्रशिक्षुओं को अत्याधुनिक तकनीकी दृष्टिकोण प्रदान करता है।",
    "NIGST ने IIIT हैदराबाद, IIT कानपुर, IIT रुड़की, IIT तिरुपति, IIIT हैदराबाद तथा AGI, NGRI जैसे अन्य प्रतिष्ठित संगठनों के साथ पारस्परिक हितों के क्षेत्रों में सहयोग स्थापित किया है, जिससे ज्ञान साझा करने और अकादमिक उत्कृष्टता को बढ़ावा मिल सके।",
    "NIGST अपने हरे-भरे 100 एकड़ परिसर में उत्कृष्ट शिक्षण वातावरण प्रदान करता है, जहाँ लगभग 200 प्रशिक्षुओं के लिए आवास और भोजन की सुविधा उपलब्ध है। संस्थान में अत्याधुनिक सर्वेक्षण उपकरण, नवीनतम तकनीकों से युक्त प्रयोगशालाएँ तथा 24/7 इंटरनेट कनेक्टिविटी और ई-ग्रंथालय सुविधा से सुसज्जित पुस्तकालय मौजूद है।",
  ],
};

//dynamic content here
const About = () => {
  const [isEnglish, setIsEnglish] = useState(true);

  const [, setEnglishText] = useState("");
  const [, setHindiText] = useState("");
  const [orgChart, setOrgChart] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleTranslate = () => {
    if (isEnglish) {
      setHindiText();
    } else {
      setEnglishText();
    }
    setIsEnglish(!isEnglish);
  };

  const getOrgChart = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/dep/get_organization_web_chart`;
      const res = await axios.get(url);
      setOrgChart(res?.data[0]?.url);
    } catch (error) {
      console.log("Error fetching organization chart:", error);
    }
  }

  useEffect(() => {
    getOrgChart();
  }, [])

  return (
    <div className="grid grid-cols-1 md:grid-cols-[300px_200px_auto_300px] gap-4 m-0 md:m-2 ">
      <div className="bg-[#f5eeee76] p-4 rounded-md flex flex-col items-center leading-normal">
        <img
          src={MessageFromHead.image}
          alt="Head"
          className="rounded-md justify-self-center max-h-40"
        />
        <Link to={"/head-biography"} className="font-semibold text-center underline  text-blue-400">
          {MessageFromHead.name}
        </Link>
        <p className="text-justify ">{MessageFromHead.description}</p>
        <div className="flex justify-start w-full">
          <button onClick={handleShowModal} className='p-1 md:p-2  bg-[#1050A2] rounded-md text-black mt-4'>Show More...</button>
        </div>
      </div>
      <div className=" bg-[#f5eeee76] p-4 rounded-md leading-normal md:col-span-2 ">
        <button
          onClick={handleTranslate}
          className="bg-blue-900 rounded-md p-2 text-white float-right   hover:bg-blue-700">
          {isEnglish ? "हिंदी" : "English"}
        </button>
        {isEnglish ? (
          <div className="english text-justify p-0 md:p-0 lg:p-4">
            <h1 className="font-extrabold text-2xl text-center pt-0 mt-0 mb-4">
              {InformationDiv.headingEnglish}
            </h1>

            {InformationDiv.englishPara.map((para, index) => (
              <p key={index}>{para}</p>
            ))}
            {orgChart && <div>
              <button
                className=" bg-[#1050A2] p-2 m-3 rounded-md"
                onClick={() => window.open(orgChart, "_blank")}>
                Click to View Structure of NIGST
              </button>
            </div>}
          </div>
        ) : (
          <div className="hindi leading-relaxed text-justify p-0 md:p-0 lg:p-4">
            <h1 className="font-extrabold text-2xl text-center pt-0 mt-0 mb-3">
              {InformationDiv.headingHindi}
            </h1>
            {InformationDiv.contentHindi.map((para, index) => (
              <p key={index}>{para}</p>
            ))}
            {orgChart && <div>
              <button
                className=" bg-blue-500 p-2 m-3 rounded-md"
                onClick={() => window.open(orgChart, "_blank")}>
                Click to View Structure of NIGST
              </button>
            </div>}
          </div>
        )}
      </div>
      <div className="rounded-md">
        <div className="flex flex-col gap-3">
          {StaticImages.map((image, index) => (
            <div key={index}>
              <img
                src={image.path}
                alt={image.title}
                className="w-full h-[250px] object-cover rounded-md"
              />
            </div>
          ))}
        </div>
      </div>
      {showModal && <BioDataModal onClose={handleCloseModal} />}
    </div>
  );
};

export default About;
